import * as React from 'react';
import { Region } from '@shapeable/kelp-forest-alliance-types';

export const RegionsContext = React.createContext<Region[]>([]);
export const RegionsProvider = RegionsContext.Provider;